import styled from "styled-components";
import media from "styled-media-query";
import customMedia from "../../config/breakpoints";

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.blueMedium};
  display: flex;
  flex-direction: row;
  padding: 40px;

  ${customMedia.lessThan("mobile")`
    flex-direction: column;
    padding: 40px 24px;
  `}
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 60%;

  ${customMedia.lessThan("tablet")`
    width: 100%;
    padding: 0px;
  `}

  a {
    color: ${({ theme }) => theme.colors.blue};
    text-decoration: underline;
    transition: all 0.3s ease;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40%;

  ${media.lessThan("medium")`
    width: 100%;
    margin-top:30px;
    justify-content: flex-start;
  `}
`;

export const Button = styled.button`
  background: ${({ theme }) => theme.colors.blueDark};
  border: 0;
  display: flex;
  align-items: center;
  width: 340px;
  height: 86px;
  padding: 0px;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.blueDarker};
  }
`;

export const ButtonText = styled.div`
  margin: 16px 10px 16px 24px;
  font-size: 18px;
  line-height: 20px;
  font-weight: 700;
  font-family: Aileron;
  color: ${({ theme }) => theme.colors.white};
  text-align: left;

  ${customMedia.lessThan("tablet")`
  font-size: 16px;
  line-height: 18px;
  `}
`;

export const IconContainer = styled.div`
  background: ${({ theme }) => theme.colors.blueDarker};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0px 16px;
  width: 50px;
`;
